var componentRequireContext = require.context("components/vof/pages/tickets/index", true)
var ReactRailsUJS = require("react_ujs")

ReactRailsUJS.useContext(componentRequireContext)
